import ouiBase from '@goldwasserexchange/oui';
import { useHookstate } from '@hookstate/core';
export var getCurrentUserIndexFromUsers = function (users) { return users.findIndex(function (user) { return user.current === true; }); };
export var useCurrentUserIndex = function () {
    var valueState = ouiBase.Form.useFormData();
    var usersState = useHookstate(valueState.onboarding.users);
    var currentUserIndex = getCurrentUserIndexFromUsers(usersState.get());
    return currentUserIndex;
};
